import Vue from 'vue'
import Router from 'vue-router'
import OverviewView from '../views/OverviewView.vue'
import InsightsView from '../views/InsightsView.vue'
import TodosView from '../views/TodosView.vue'
import NotFoundView from '../views/NotFoundView.vue'

Vue.use(Router)

const routerBase = window.__POWERED_BY_QIANKUN__ ? '/vue2-app' : '/'

export default new Router({
  mode: 'history',
  base: routerBase,
  routes: [
    {
      path: '/',
      name: 'overview',
      component: OverviewView,
    },
    {
      path: '/insights',
      name: 'insights',
      component: InsightsView,
    },
    {
      path: '/todos',
      name: 'todos',
      component: TodosView,
    },
    {
      path: '*',
      name: 'not-found',
      component: NotFoundView,
    },
  ],
})
